<template>
    <div v-if="task.output">
        <div class="tasks-bar-buttons">
            <a :href="task.output.csvUrl" v-if="task.output.csvUrl" target="_blank" @click="done()">
                <i class="fa-file"></i>
                CSV
            </a>
            <a :href="task.output.xlsxUrl" v-if="task.output.xlsxUrl" target="_blank" v-tooltip title="Excel 2007 ou superior" @click="done()">
                <i class="fa-file"></i>
                Excel
            </a>
            <a :href="task.output.jsonUrl" v-if="task.output.jsonUrl" target="_blank" @click="done()">
                <i class="fa-file"></i>
                JSON
            </a>
            <a :href="task.output.xmlUrl" v-if="task.output.xmlUrl" target="_blank" @click="done()">
                <i class="fa-file"></i>
                XML
            </a>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            task: {
                type: Object
            },
            done: {
                type: Function
            }
        }
    }
</script>


// WEBPACK FOOTER //
// ExportCustomersV1.vue?0eea3612